import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./../Pages/Home";
import Tours from "./../Pages/Tour";
import TourDetails from "./../Pages/TourDetails";
import Login from "./../Pages/Login";
import Register from "./../Pages/Register";
import SearchResult from "./../Pages/SearchResultList";
import ThankYou from "./../Pages/ThankYou";
import CabBooking from "./../Pages/CabBooking";
import CabSearchResults from "./../Pages/CabSearchResults";
import CabBookingSuccess from "./../Pages/CabBookingSuccess";
import MyCabBookings from "./../Pages/MyCabBookings";

const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/home" element={<Home />} />
      <Route path="/tours" element={<Tours />} />
      <Route path="/tours/:id" element={<TourDetails />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/thank-you" element={<ThankYou/>} />
      <Route path="/tours/search" element={<SearchResult />} />
      <Route path="/cabs" element={<CabBooking />} />
      <Route path="/cabs/search" element={<CabSearchResults />} />
      <Route path="/cab-booking-success" element={<CabBookingSuccess />} />
      <Route path="/my-cab-bookings" element={<MyCabBookings />} />
    </Routes>
  );
};

export default Routers;
